import '../App.css';
import Header from '../components/Header';
import Talent from '../components/Talent';
import USP from '../components/USP';
import Expertise from '../components/Expertise';
import Whyus from '../components/Whyus';

const Home = () => {
    return (
        <>
            <Header/>
            <Talent/>
            <USP/>
            <Expertise/>
            <Whyus/>
        </>
    )
}

export default Home;